module.exports = __webpack_public_path__ + "static/img/logo-new.33d8de6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-new.png
// module id = RTXg
// module chunks = 1